import axios from 'axios';

const baseAPI = process.env.REACT_APP_BASE_API;
const instance = axios.create();
instance.defaults.baseURL = baseAPI;

const onFulfilledReq = (config: any) => {
  config.headers['ACCEPT-LANGUAGE'] = localStorage.getItem('i18next') || 'en';
  return config;
};

const onRejectedReq = (error: any) => {
  return Promise.reject(error);
};

const onFulfilledRes = (response: any) => {
  return response;
};

const onRejectedRes = (error: any) => {
  return Promise.reject(error);
};

instance.interceptors.request.use(onFulfilledReq, onRejectedReq);
instance.interceptors.response.use(onFulfilledRes, onRejectedRes);

export default instance;
